import { IdentityAccount } from './identityAccount'
import { DeliveryModel, Journey, Solution } from '@audibene/ta.utils-opportunity'

enum Country {
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  FR = 'FR',
  IN = 'IN',
  KR = 'KR',
  MY = 'MY',
  NL = 'NL',
  US = 'US',
  ZA = 'ZA',
}

enum DeliveryLocationType {
  CUSTOMER = 'CUSTOMER',
  PARTNER_SHOP = 'PARTNER_SHOP',
  WAREHOUSE = 'WAREHOUSE',
}

enum Side {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

enum SalesOrderLineStatus {
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED',
  DELIVERED = 'DELIVERED',
  EXTERNAL_PROCESSING = 'EXTERNAL_PROCESSING',
  INTERNAL_PROCESSING = 'INTERNAL_PROCESSING',
  SHIPPED = 'SHIPPED',
}

enum SalesOrderStatus {
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED',
  DELIVERED = 'DELIVERED',
  DELIVERY_CONFIRMED = 'DELIVERY_CONFIRMED',
  PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED',
  PARTIALLY_SHIPPED = 'PARTIALLY_SHIPPED',
  PROCESSING = 'PROCESSING',
  SHIPPED = 'SHIPPED',
}

enum Subcategory {
  BATTERY = 'BATTERY',
  CHARGER = 'CHARGER',
  COLORKIT = 'COLORKIT',
  CROS = 'CROS',
  DEMO = 'DEMO',
  DOME = 'DOME',
  EARMOLD = 'EARMOLD',
  EARMOLDUPGR = 'EARMOLDUPGR',
  INSURANCE = 'INSURANCE',
  MICROPHONE = 'MICROPHONE',
  MOLDREC = 'MOLDREC',
  PHONE = 'PHONE',
  REMOTE = 'REMOTE',
  REPAIR = 'REPAIR',
  SDCON = 'SDCON',
  SDHA = 'SDHA',
  SDMISC = 'SDMISC',
  SDREC = 'SDREC',
  SDSERV = 'SDSERV',
  STREAMER = 'STREAMER',
  TUBE = 'TUBE',
  VOUCHER = 'VOUCHER',
  WARRANTY = 'WARRANTY',
}

enum Category {
  CON = 'CON',
  HA = 'HA',
  MISC = 'MISC',
  MOBILE = 'MOBILE',
  REC = 'REC',
  SERV = 'SERV',
  TABLET = 'TABLET',
}

interface Address {
  contactName: string
  companyName?: string
  streetNo?: string
  addressLine1: string
  addressLine2?: string
  addressLine3?: string
  city: string
  state: string
  country: string
  postalCode: string
  phone?: string
  email?: string
}

interface DeliveryLocation {
  id: string
  gid: string
  countryCode: Country
  type: DeliveryLocationType
  name: string
  address: Address
  createdAt: Date
  updatedAt: Date
}

interface Color {
  id: string
  gid: string
  code: string
  name: string
}

interface InventoryItem {
  gid?: number
  id: string
  isSubstitute?: boolean
  itemColorId?: string
  itemGid?: string
  itemId?: string
  serialNumber?: string
  stockId?: string
}

interface SalesOrderItem {
  id: string
  gid: string
  code: string
  name: string
  color?: Color
  categoryCode: Category
  subcategoryCode?: Subcategory
  isTrackable: boolean
}

interface JourneyDetails {
  journey: Journey
  deliveryModel: DeliveryModel
  solution: Solution
}

enum SalesOrderType {
  FIRST_APPOINTMENT = 'FIRST_APPOINTMENT',
  FOLLOW_UP = 'FOLLOW_UP',
  INITIAL = 'INITIAL',
}

interface SalesOrderStatusHistory {
  id: string
  salesOrderId: string
  status: SalesOrderStatus
  createdAt: Date
  createdBy: IdentityAccount
}

interface SalesOrderLineStatusHistory {
  id: string
  salesOrderId: string
  salesOrderLineId: string
  status: SalesOrderLineStatus
  createdAt: Date
  createdBy: IdentityAccount
}

interface SalesOrderLine {
  id: string
  gid: string
  status: SalesOrderLineStatus
  side?: Side
  item: SalesOrderItem
  quantity: number
  inventoryItem?: InventoryItem
  createdAt: Date
  updatedAt: Date
}

interface SalesOrderHeader {
  id: string
  gid: string
  countryCode: Country
  customerGid: string
  opportunityGid?: string
  journeyDetails?: JourneyDetails
  status: SalesOrderStatus
  type: SalesOrderType
  createdAt: Date
  updatedAt: Date
  createdBy: IdentityAccount
  updatedBy: IdentityAccount
}

interface PersistedSalesOrder extends SalesOrderHeader {
  lines: SalesOrderLine[]
  deliveryLocationId: string
}

interface SalesOrder extends SalesOrderHeader {
  lines: SalesOrderLine[]
  deliveryLocation: DeliveryLocation
}

enum SalesOrderLineAction {
  CANCEL = 'CANCEL',
  UNCANCEL = 'UNCANCEL',
  PROCESS_INTERNALLY = 'PROCESS_INTERNALLY',
  PROCESS_EXTERNALLY = 'PROCESS_EXTERNALLY',
  UNPROCESS = 'UNPROCESS',
  SHIP = 'SHIP',
  UNSHIP = 'UNSHIP',
  DELIVER = 'DELIVER',
  UNDELIVER = 'UNDELIVER',
}

enum SalesOrderAction {
  CANCEL = 'CANCEL',
  UNCANCEL = 'UNCANCEL',
}

enum SalesOrderRelationType {
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  WAREHOUSE_ORDER = 'WAREHOUSE_ORDER',
  SHIPMENT = 'SHIPMENT',
  RETURN_WAREHOUSE_ORDER = 'RETURN_WAREHOUSE_ORDER',
}

interface SalesOrderRelation {
  id: string
  salesOrderId: string
  salesOrderGid: string
  salesOrderLineId?: string
  salesOrderLineGid?: string
  relatedId: string
  relatedGid: string
  relatedLineId?: string
  relatedLineGid?: string
  type: SalesOrderRelationType
  createdAt: Date
}

export type {
  PersistedSalesOrder,
  SalesOrder,
  SalesOrderHeader,
  SalesOrderItem,
  SalesOrderLine,
  SalesOrderLineStatusHistory,
  SalesOrderRelation,
  SalesOrderStatusHistory,
}
export {
  Category,
  SalesOrderAction,
  SalesOrderLineAction,
  SalesOrderLineStatus,
  SalesOrderRelationType,
  SalesOrderStatus,
  SalesOrderType,
}
